import jaCountries from '@/globals/jaCountries';
import countyCodes from '@/globals/countyCodes';

export const getCountryCodeList = () => {
  return countyCodes
    .map((country) => {
      return {
        code: `+${country.countryCodes[0].replace('-', ' ')}`,
        name: jaCountries[country.isoCode2] || country.country,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name), 'ja');
};
